<template>
	<PopupRouterView :showLeftIcon="true" label="Approval Instance Input"  entityName="approvalinstance" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-approval-tag" label-cols-sm="4" label-cols-lg="3" label="Approval Tag" label-for="input-approval-tag" size="sm" :model.sync="model.approvalTag"  @change="updateData" />
				<app-input-combobox-autocomplete :options="approvalConfigurations" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration" id="input-" size="sm" :model.sync="model.approvalConfigurationId"  :selected="model.approvalConfiguration != null ? model.approvalConfiguration.name : ''" @input="getApprovalConfigurations" @change="updateData"/>
				<app-input-combobox-autocomplete :options="approvalConfigurationInstances" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration Instance" id="input-" size="sm" :model.sync="model.approvalConfigurationInstanceId"  :selected="model.approvalConfigurationInstance != null ? model.approvalConfigurationInstance.name : ''" @input="getApprovalConfigurationInstances" @change="updateData"/>
				<app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="input-" size="sm" :model.sync="model.approvalTypeId"  :selected="model.approvalType != null ? model.approvalType.name : ''" @input="getApprovalTypes" @change="updateData"/>
				<app-input-textbox id="fieldset-current-approver-sequence" label-cols-sm="4" label-cols-lg="3" label="Current Approver Sequence" label-for="input-current-approver-sequence" size="sm" :model.sync="model.currentApproverSequence"  @change="updateData" />
				<app-input-combobox-autocomplete :options="approvalStates" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval State" id="input-" size="sm" :model.sync="model.approvalStateId"  :selected="model.approvalState != null ? model.approvalState.name : ''" @input="getApprovalStates" @change="updateData"/>
				<app-input-textbox id="fieldset-document-id" label-cols-sm="4" label-cols-lg="3" label="Document Id" label-for="input-document-id" size="sm" :model.sync="model.documentId"  @change="updateData" />
				<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="input-status" size="sm" :model.sync="model.status"  @change="updateData" />
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Originator" id="input-" size="sm" :model.sync="model.originatorId"  :selected="model.originator != null ? model.originator.firstName : ''" @input="getUserInfos" @change="updateData"/>
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="input-" size="sm" :model.sync="model.approvalStructureId"  :selected="model.approvalStructure != null ? model.approvalStructure.name : ''" @input="getApprovalStructures" @change="updateData"/>
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
	<b-card class="mt-3" header-bg-variant="transparent">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approvers State</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approverStatePageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<app-table-input :items="approverStates" :fields="fieldsApproverState" :busy="isDataLoading" :sort-by.sync="sortByApproverState" :sort-desc.sync="sortDescApproverState" small responsive
			@editButtonMethod="editRowDataApproverState"
			@deleteButtonMethod="deleteRowDataApproverState"
			@showPopupAddMethod="addDataApproverState()"
			@showPopupUploadMethod="showPopupUploadApproverState()"
			@downloadMethod="downloadApproverState()"
			@addFromClipboardMethod="addFromClipboardApproverState()"
			@replaceFromClipboardMethod="replaceFromClipboardApproverState()"
			:showActionButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="true"
			:showReplaceFromClipboardButton="true"
			:showUploadButton="true"
			:showDownloadButton = "true"
			:isDownloadBusy = "isDownloadApproverState"
			>
			<template v-slot:head(actions)>
				<b-button @click="isShowApproverStateFilter = !isShowApproverStateFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowApproverStateFilter">
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes" :value="filterApproverState.approverTypeId" :reduce="item => item.id" v-model="filterApproverState.approverTypeId" @search="getApproverTypes" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filterApproverState.approvalStructureId" :reduce="item => item.id" v-model="filterApproverState.approvalStructureId" @search="getApprovalStructures" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApproverState.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filterApproverState.approverUserId" :reduce="item => item.id" v-model="filterApproverState.approverUserId" @search="getUserInfos" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Activity State">
					<v-select append-to-body label="name" :options="activityStates" :value="filterApproverState.activityStateId" :reduce="item => item.id" v-model="filterApproverState.activityStateId" @search="getActivityStates" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Configuration Detail">
					<v-select append-to-body label="approverType" :options="approvalConfigurationInstanceDetails" :value="filterApproverState.approvalConfigurationInstanceDetailId" :reduce="item => item.id" v-model="filterApproverState.approvalConfigurationInstanceDetailId" @search="getApprovalConfigurationInstanceDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Sequence">
					<b-form-input id="input-sequence-table" v-model="filterApproverState.sequence" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApproverState.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApproverState.isSendNotification"></b-form-checkbox>
				</b-th>
				<b-th>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approverStatePageSize * (currentApproverStatePage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
			<b-spinner class="align-middle text-primary"></b-spinner>
				<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(approverType)="row">
				<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" id="input-" size="sm" :model.sync="row.item.approverTypeId"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(approvalStructure)="row">
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" id="input-" size="sm" :model.sync="row.item.approvalStructureId"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(approverLevel)="row">
				<app-input-textbox id="fieldset-approver-level" size="sm" :model.sync="row.item.approverLevel"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(approverUser)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" id="input-" size="sm" :model.sync="row.item.approverUserId"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(activityState)="row">
				<app-input-combobox-autocomplete :options="activityStates" optionsLabel="name" optionsKey="id" id="input-" size="sm" :model.sync="row.item.activityStateId"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(approvalConfigurationInstanceDetail)="row">
				<app-input-combobox-autocomplete :options="approvalConfigurationInstanceDetails" optionsLabel="approverType" optionsKey="id" id="input-" size="sm" :model.sync="row.item.approvalConfigurationInstanceDetailId"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(sequence)="row">
				<app-input-textbox id="fieldset-sequence" size="sm" :model.sync="row.item.sequence"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(storedProcedureName)="row">
				<app-input-textbox id="fieldset-stored-procedure-name" size="sm" :model.sync="row.item.storedProcedureName"   @change="saveInputApproverState(row.item)" />
			</template>
			<template v-slot:cell(isSendNotification)="row">
				<b-form-checkbox :id="'input-is-send-notification-' + row.index" v-model="row.item.isSendNotification"  @change="saveInputApproverState(row.item)"></b-form-checkbox>
			</template>
				<template v-slot:form-add-detail>
				<ApproverStateInput 
					:model="modelApproverState"
					:openPopup="isShowPopupApproverState"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataApproverState"/>
				</template>
				<template v-slot:upload-detail>
					<ApproverStateUpload
					:openPopup="isShowPopupUploadApproverState"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataApproverState"
					:parentId="modelId"
				 />
				</template>
			<template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentApproverStatePage"
				:total-rows="totalApproverStateRow"
				:per-page="approverStatePageSize"
				aria-controls="my-table"
				></b-pagination>
			</template>
			</app-table-input>
		</b-col>
		</b-row>
	</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :modelId="modelId" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceList from '@/models/ApprovalInstance/ApprovalInstanceList';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';
import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import ApprovalState from '@/models/ApprovalState/ApprovalState';
import ApprovalStateFilter from '@/filters/ApprovalState/ApprovalStateFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApproverState from '@/models/ApprovalInstance/ApproverState';
import ApproverStateFilter from '@/filters/ApprovalInstance/ApproverStateFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ApproverStateInput from '@/views/ApprovalInstance/ApproverStateInput';
import ApproverStateUpload from '@/views/ApprovalInstance/ApproverStateUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputComboboxAutocomplete,ApproverStateInput,ApproverStateUpload,AppTableInput,AppTableInputPopup,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsApproverState: [
				{"no" : { "class" : "th-number"}}, 
				{"approverType": { "class" : "th-approver-type"}, "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure"}, "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level"}, "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUser": { "class" : "th-approver-user"}, "label" : "Approver User", key: 'approverUser', sortable: true}, 
				{"activityState": { "class" : "th-activity-state"}, "label" : "Activity State", key: 'activityState', sortable: true}, 
				{"approvalConfigurationInstanceDetail": { "class" : "th-approval-configuration-instance-detail"}, "label" : "Approval Configuration Detail", key: 'approvalConfigurationInstanceDetail', sortable: true}, 
				{"sequence": { "class" : "th-sequence"}, "label" : "Sequence", key: 'sequence', sortable: true}, 
				{"storedProcedureName": { "class" : "th-stored-procedure-name"}, "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"isSendNotification": { "class" : "th-is-send-notification"}, "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelApproverState : {},
			isShowPopupApproverState : false,
			isShowPopupUploadApproverState : false,
			filterApprovalInstance : null,
			currentApprovalInstancePage : 1,
			approvalInstancePageSize: 10,
			sortByApprovalInstance: '',
			sortDescApprovalInstance: '',
			filterApproverState : null,
			currentApproverStatePage : 1,
			approverStatePageSize: 10,
			sortByApproverState: '',
			sortDescApproverState: '',
			sortingByApproverState: [],
			approverStates : [],
			approverStateId : '',
			totalApproverStateRow : 0,
			isShowApproverStateFilter: false,
			isDownloadApproverState: false,
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			activityStates: [],
			approvalConfigurationInstanceDetails: [],
			approvalConfigurations: [],
			approvalConfigurationInstances: [],
			approvalTypes: [],
			approvalStates: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getApprovalInstance : async function(id) {
			this.isBusy = true;
			ApprovalInstance.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalInstance = true;
			this.filterApprovalInstance.id = this.modelId;
			ApprovalInstance.downloadDataDetail(this, this.filterApprovalInstance).then(result => {
				this.isDownloadApprovalInstance = false;
			}).catch(error => { this.isDownloadApprovalInstance = false; })
		},
		getApproverStates : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterApproverState);
			if (this.modelId == null) return;
			filter.approvalInstanceId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByApproverState != null) {
				this.sortingByApproverState[this.sortByApproverState] = this.sortDescApproverState;
			}
			let currentPage = (this.currentApproverStatePage - 1);
			if (isAddRow) {
				let totalData = this.totalApproverStateRow + 1;
				let page = Math.ceil(totalData/this.approverStatePageSize);
				currentPage = page - 1;
			}
			ApproverState.getList(this, filter, this.sortingByApproverState, currentPage , this.approverStatePageSize).then(result => {
				this.currentApproverStatePage = currentPage + 1;
				this.approverStates = result.data;
				this.totalApproverStateRow = result.dataCount;
			}).catch(error => {});
		},
		getApprovalInstances : async function(input) {
			let filter = new ApprovalInstanceFilter();
			if (input != undefined) {
				filter.approvalTag = input;
			}
			ApprovalInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurations : async function(input) {
			let filter = new ApprovalConfigurationFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstances : async function(input) {
			let filter = new ApprovalConfigurationInstanceFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfigurationInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStates : async function(input) {
			let filter = new ApprovalStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStates = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalInstance.commitData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvalinstanceindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalInstance.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvalinstanceindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ApprovalInstance.updateData(this, model, id);
				}
			});
		},
		onHidden() {
			this.getApprovalInstances();
		},
		addRowDataApproverState(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.approvalInstanceId =  this.modelId;
					ApproverState.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getApproverStates(true);
						this.isShowPopupApproverState = false;
					})
				} else {
					model.approvalInstanceId =  this.modelId;
					ApproverState.createDataDetail(this, model)
					.then(result => {
						this.getApproverStates(true);
						this.isShowPopupApproverState = false;
					})
				}
			}
		},
		async editRowDataApproverState(id) {
			this.approverStateId = id;
			this.isShowPopupApproverState = true; 
		},
		async deleteRowDataApproverState(id) {
			ApproverState.deleteData(this, id).then(result => { this.getApproverStates(); });
		},
		async resetDataApproverState() {
			this.approverStateId = "";
			this.isShowPopupApproverState = true;
		},
		async addDataApproverState() {
			ApproverState.createDataDetail(this, { approvalInstanceId: this.modelId })
			.then(result => {
				this.getApproverStates(true);
			})
		},
		async addFromClipboardApproverState() {
			let approverTypes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					approverTypes.push({ approverType: item, approvalInstanceId: this.modelId });
				});
				ApproverState.addFromClipboard(this, approverTypes).then(result => { this.getApproverStates() });
			});
		},
		async replaceFromClipboardApproverState() {
			let approverTypes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					approverTypes.push({ approverType: item, approvalInstanceId: this.modelId });
				});
				ApproverState.replaceFromClipboard(this, approverTypes).then(result => { this.getApproverStates() });
			});   
		},
		showPopupUploadApproverState() {
			this.isShowPopupUploadApproverState = true;
		},
		uploadDataApproverState(modalEvent, newDatas) {
			this.isShowPopupUploadApproverState = false; 
		},
		downloadApproverState(modalEvent) {
			this.isDownloadApproverState = true;
			this.filterApproverState.approvalInstanceId = this.modelId;
			ApproverState.downloadDataDetail(this, this.filterApproverState).then(result => {
				this.isDownloadApproverState = false;
			}).catch(error => { this.isDownloadApproverState = false; })
		},
		saveInputApproverState(item) {
			ApproverState.updateDataDetail(this, item, item.id);
		},
		resetModal(modalType) {
			this.isShowPopupUploadApproverState = false; 
			this.isShowPopupApproverState = false; 
			if (modalType == 'ApproverState') {
				this.getApproverStates();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApproverStateFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterApprovalInstance = new ApprovalInstanceFilter();
		this.filterApproverState = new ApproverStateFilter();
		this.getApprovalInstances();
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getUserInfos();
		this.getActivityStates();
		this.getApprovalConfigurationInstanceDetails();
		this.getApprovalConfigurations();
		this.getApprovalConfigurationInstances();
		this.getApprovalTypes();
		this.getApprovalStates();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalInstance(id);
			} else {
				this.modelId = id;
				this.getApprovalInstance(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		sortByApproverState : {
			handler: function() {
				this.getApproverStates();
			}
		},
		sortDescApproverState: {
			handler: function() {
				this.getApproverStates();
			}
		},
		currentApproverStatePage: {
			handler: function() {
				this.getApproverStates();
			}
		},
		approverStatePageSize : {
			handler: function() {
				this.getApproverStates();
			}
		},
		filterApproverState: {
			handler: function() {
				this.getApproverStates();
			},
			deep: true,
		},
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			ApprovalInstance.discardData(this, this.modelId);
		}
	},
}
</script>
